import { Component, OnInit, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { FileNavigatorService } from '../../services'

@Component({
  selector: 'app-fm-sidebar',
  templateUrl: './fm-sidebar.component.html',
  providers: []
})

export class FmSidebarComponent implements OnInit, OnDestroy {

  /**
   * Subscriptions
   */
  private subscriptions: Array<Subscription> = []

  /**
   * Constructor
   */
  public constructor (
    public fileNavigatorService: FileNavigatorService
  ) {}

  /**
   * On destroy
   */
  public ngOnDestroy (): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

  /**
   * On init
   */
  public ngOnInit (): void {
  }

}
